module.exports = __webpack_public_path__ + "067fa00f6df432e4181d152b9c2ec9f1.png";


//////////////////
// WEBPACK FOOTER
// ./shared/components/Logo/assets/cetabever/eesbru.png
// module id = 2680
// module chunks = 0